<template>
    <div class="box chart-holder">
        <h2>
            {{ t('quotations-budget_and_billing_by') }}
            <span
                v-for="(set, index) in availableSets"
                v-if="groupDataBy === set"
                :key="index"
            >
                {{ t("dates-" + set) }}
            </span>

            <template v-if="availableSets.length > 1">
                <button
                    class="btn btn-sm btn-info pull-right btn-chart-menu"
                    @click="showOptions = !showOptions"
                >
                    <span
                        class="far"
                        :class="{
                            'fa-cogs': !showOptions,
                            'fa-remove': showOptions,
                        }"
                    ></span>
                </button>
            </template>
        </h2>
        <template v-if="availableSets.length > 1">
            <div class="chart-options-menu" v-if="showOptions">
                <label>{{ t('quotations-group_by') }}</label>
                <ul>
                    <li
                        v-for="(set, index) in availableSets"
                        :class="{ selected: groupDataBy === set }"
                        @click="setGroupDataBy(set)"
                        :key="index"
                    >
                        {{ t("dates-" + set) }}
                    </li>
                </ul>
            </div>
        </template>
        <div class="clear"></div>
        <div style="height: 218px">
            <bar-chart
                :chart-data="quotationsChartData"
                :style="myStyles"
                :options="chartOptions"
                :height="218"
                ref="chart"
            />
        </div>
    </div>
</template>
<script>
import BarChart from "../components/charts/barChart";
export default {
    components: { BarChart },
    data() {
        return {
            showOptions: false,
            groupDataBy: "day",
            myStyles: {
                height: "218px",
                width: "100%",
                position: "relative",
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        label: (tooltipItems, data) => {
                            if (
                                data.datasets[tooltipItems.datasetIndex].label ===
                                this.t('quotations-billing')
                            ) {
                                return (
                                    this.currencySymbol + " " +
                                    parseFloat(tooltipItems.yLabel).toLocaleString(
                                        "pt-BR",
                                    )
                                );
                            }
                            return tooltipItems.yLabel;
                        },
                    },
                },
                scales: {
                    yAxes: [
                        {
                            id: "L",
                            type: "linear",
                            position: "left",
                            ticks: {
                                maxTicksLimit: 6,
                                beginAtZero: true,
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.t('quotations-budget'),
                            },
                        },
                        {
                            gridLines: false,
                            id: "R",
                            type: "linear",
                            position: "right",
                            ticks: {
                                maxTicksLimit: 6,
                                beginAtZero: true,
                                callback: (value, index, values) => {
                                    return (
                                        this.currencySymbol + " " + parseFloat(value).toLocaleString()
                                    );
                                },
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.t('quotations-billing'),
                            },
                        },
                    ],
                },
            },
        };
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        setGroupDataBy(period) {
            this.groupDataBy = period;
            this.showOptions = false;
            this.$refs.chart.renderChart(
                this.quotationsChartData,
                this.chartOptions,
            );
        },
    },
    mounted() {
        setTimeout(() => {
            this.setGroupDataBy(this.availableSets[0] ?? 'day');
        }, 200);
    },
    props: {
        chart: {
            type: Array,
            required: true,
        }
    },
    computed: {
        availableSets() {
            let sets = [];
            for (let s in this.chart) {
                sets.push(this.chart[s].groupBy);
            }
            return sets;
        },

        quotationsChartData() {
            for (let s in this.chart) {
                let set = this.chart[s];
                if (set.groupBy === this.groupDataBy) {
                    return {
                        labels: set.labels,
                        datasets: [
                            {
                                label: this.t('quotations-billing'),
                                borderColor: "#FDB000",
                                borderWidth: 2,
                                pointRadius: 3,
                                pointBackgroundColor: "#EEE",
                                backgroundColor: "rgba(0,0,0,0)",
                                type: "line",
                                lineTension: 0,
                                yAxisID: "R",
                                data: set.income,
                            },
                            {
                                label: this.t('quotations-budget'),
                                backgroundColor: "#A7CCC0",
                                yAxisID: "L",
                                data: set.quotations,
                            },
                        ],
                    };
                }
            }
        },
    },
    watch: {
    chart: {
        handler(newVal) {
            if (newVal && newVal.length > 0) {
                this.setGroupDataBy(this.availableSets[0] ?? "day");
            }
        },
        immediate: true,
        deep: true,
    },
},

};
</script>
